var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroTagline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 451,
    height: 177,
    viewBox: "0 0 451 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1003_148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.008 79.816V69.448H36.928C40.816 69.448 43.216 71.224 43.216 74.584V74.68C43.216 77.752 40.912 79.816 37.072 79.816H29.008ZM21.664 97.72H29.008V86.344H35.392L43.12 97.72H51.76L43.024 85.096C47.536 83.512 50.656 79.96 50.656 74.296V74.2C50.656 70.984 49.648 68.248 47.728 66.328C45.424 64.024 41.968 62.776 37.552 62.776H21.664V97.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.856 98.296C78.16 98.296 84.304 92.104 84.304 84.424V84.328C84.304 76.696 78.208 70.552 70 70.552C61.696 70.552 55.552 76.792 55.552 84.424V84.52C55.552 92.2 61.648 98.296 69.856 98.296ZM70 92.056C65.68 92.056 62.752 88.504 62.752 84.424V84.328C62.752 80.248 65.44 76.84 69.856 76.84C74.176 76.84 77.104 80.344 77.104 84.424V84.52C77.104 88.6 74.416 92.056 70 92.056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.061 98.248C112.397 98.248 118.253 93.304 118.253 84.424V84.328C118.253 75.448 112.301 70.552 106.061 70.552C102.077 70.552 99.4847 72.472 97.6127 75.016V61.288H90.3167V97.72H97.6127V94.12C99.4367 96.328 101.981 98.248 106.061 98.248ZM104.237 92.008C100.589 92.008 97.5168 88.984 97.5168 84.424V84.328C97.5168 79.768 100.589 76.744 104.237 76.744C107.885 76.744 110.957 79.768 110.957 84.328V84.424C110.957 89.08 107.885 92.008 104.237 92.008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.356 98.296C145.66 98.296 151.804 92.104 151.804 84.424V84.328C151.804 76.696 145.708 70.552 137.5 70.552C129.196 70.552 123.052 76.792 123.052 84.424V84.52C123.052 92.2 129.148 98.296 137.356 98.296ZM137.5 92.056C133.18 92.056 130.252 88.504 130.252 84.424V84.328C130.252 80.248 132.94 76.84 137.356 76.84C141.676 76.84 144.604 80.344 144.604 84.424V84.52C144.604 88.6 141.916 92.056 137.5 92.056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.841 98.152C169.337 98.152 171.113 97.576 172.697 96.664V90.808C171.593 91.384 170.345 91.72 168.953 91.72C167.177 91.72 166.361 90.856 166.361 88.984V77.272H172.793V71.032H166.361V64.12H159.065V71.032H155.849V77.272H159.065V90.184C159.065 96.328 162.233 98.152 166.841 98.152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.055 67.864H186.734V61.336H179.055V67.864ZM179.294 97.72H186.542V71.032H179.294V97.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.815 98.296C212.095 98.296 215.119 96.28 217.711 93.4L213.439 89.128C211.567 90.904 209.743 92.056 207.151 92.056C202.879 92.056 200.143 88.648 200.143 84.424V84.328C200.143 80.248 202.927 76.84 206.863 76.84C209.599 76.84 211.327 78.04 213.055 79.864L217.567 75.064C215.071 72.28 211.903 70.552 206.911 70.552C198.751 70.552 192.943 76.84 192.943 84.424V84.52C192.943 92.152 198.799 98.296 206.815 98.296Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.426 98.2C238.186 98.2 242.602 95.512 242.602 89.656V89.56C242.602 84.664 238.234 82.888 234.49 81.688C231.562 80.68 228.922 79.96 228.922 78.376V78.28C228.922 77.128 229.978 76.264 231.898 76.264C233.914 76.264 236.554 77.224 239.194 78.76L241.978 73.72C239.098 71.8 235.45 70.648 232.09 70.648C226.714 70.648 222.346 73.672 222.346 79.048V79.144C222.346 84.28 226.618 86.008 230.41 87.112C233.386 88.024 236.026 88.6 236.026 90.328V90.424C236.026 91.72 234.922 92.584 232.618 92.584C230.122 92.584 227.05 91.48 224.17 89.368L221.002 94.216C224.506 96.952 228.682 98.2 232.426 98.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.286 97.72H272.534V77.272H278.774V71.32H272.438V70.168C272.438 68.056 273.494 67.096 275.318 67.096C276.662 67.096 277.67 67.336 278.822 67.72V61.672C277.43 61.24 275.846 60.952 273.494 60.952C270.854 60.952 268.79 61.624 267.398 63.016C266.006 64.456 265.286 66.568 265.286 69.544V71.272H262.07V77.272H265.286V97.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.887 98.296C304.191 98.296 310.335 92.104 310.335 84.424V84.328C310.335 76.696 304.239 70.552 296.031 70.552C287.727 70.552 281.583 76.792 281.583 84.424V84.52C281.583 92.2 287.679 98.296 295.887 98.296ZM296.031 92.056C291.711 92.056 288.783 88.504 288.783 84.424V84.328C288.783 80.248 291.471 76.84 295.887 76.84C300.207 76.84 303.135 80.344 303.135 84.424V84.52C303.135 88.6 300.447 92.056 296.031 92.056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.348 97.72H323.644V87.784C323.644 81.304 326.86 78.184 331.948 78.184H332.332V70.552C327.82 70.36 325.228 72.808 323.644 76.552V71.032H316.348V97.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.981 98.152C364.477 98.152 366.253 97.576 367.837 96.664V90.808C366.733 91.384 365.485 91.72 364.093 91.72C362.317 91.72 361.501 90.856 361.501 88.984V77.272H367.933V71.032H361.501V64.12H354.205V71.032H350.989V77.272H354.205V90.184C354.205 96.328 357.373 98.152 361.981 98.152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.051 97.72H381.347V82.792C381.347 79.096 383.315 77.128 386.339 77.128C389.363 77.128 391.139 79.096 391.139 82.792V97.72H398.435V80.488C398.435 74.344 395.027 70.552 389.267 70.552C385.379 70.552 383.075 72.616 381.347 74.872V61.288H374.051V97.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.08 98.296C422.928 98.296 426.48 96.424 428.976 93.352L424.8 89.656C422.688 91.624 420.816 92.44 418.176 92.44C414.672 92.44 412.176 90.568 411.456 86.92H430.224C430.272 86.248 430.32 85.576 430.32 85C430.32 77.416 426.192 70.552 417.36 70.552C409.632 70.552 404.208 76.792 404.208 84.424V84.52C404.208 92.68 410.112 98.296 418.08 98.296ZM411.36 82.36C411.936 78.76 414.096 76.408 417.36 76.408C420.72 76.408 422.736 78.856 423.216 82.36H411.36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.664 155.72H29.008V142.04H45.904V135.32H29.008V127.496H48.112V120.776H21.664V155.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9166 156.248C66.8046 156.248 69.1086 154.184 70.8366 151.88V155.72H78.1326V129.032H70.8366V143.96C70.8366 147.656 68.8686 149.624 65.8446 149.624C62.8206 149.624 61.0446 147.656 61.0446 143.96V129.032H53.7966V146.264C53.7966 152.408 57.1566 156.248 62.9166 156.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4658 156.152C96.9618 156.152 98.7377 155.576 100.322 154.664V148.808C99.2177 149.384 97.9698 149.72 96.5778 149.72C94.8018 149.72 93.9857 148.856 93.9857 146.984V135.272H100.418V129.032H93.9857V122.12H86.6898V129.032H83.4738V135.272H86.6898V148.184C86.6898 154.328 89.8578 156.152 94.4658 156.152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.464 156.248C119.352 156.248 121.655 154.184 123.383 151.88V155.72H130.68V129.032H123.383V143.96C123.383 147.656 121.416 149.624 118.392 149.624C115.368 149.624 113.591 147.656 113.591 143.96V129.032H106.343V146.264C106.343 152.408 109.703 156.248 115.464 156.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.989 155.72H145.285V145.784C145.285 139.304 148.501 136.184 153.589 136.184H153.973V128.552C149.461 128.36 146.869 130.808 145.285 134.552V129.032H137.989V155.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.049 156.296C175.897 156.296 179.449 154.424 181.945 151.352L177.769 147.656C175.657 149.624 173.785 150.44 171.145 150.44C167.641 150.44 165.145 148.568 164.425 144.92H183.193C183.241 144.248 183.289 143.576 183.289 143C183.289 135.416 179.161 128.552 170.329 128.552C162.601 128.552 157.177 134.792 157.177 142.424V142.52C157.177 150.68 163.081 156.296 171.049 156.296ZM164.329 140.36C164.905 136.76 167.065 134.408 170.329 134.408C173.689 134.408 175.705 136.856 176.185 140.36H164.329Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.747 156.296C226.051 156.296 232.195 150.104 232.195 142.424V142.328C232.195 134.696 226.099 128.552 217.891 128.552C209.587 128.552 203.443 134.792 203.443 142.424V142.52C203.443 150.2 209.539 156.296 217.747 156.296ZM217.891 150.056C213.571 150.056 210.643 146.504 210.643 142.424V142.328C210.643 138.248 213.331 134.84 217.747 134.84C222.067 134.84 224.995 138.344 224.995 142.424V142.52C224.995 146.6 222.307 150.056 217.891 150.056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.551 155.72H246.799V135.272H253.039V129.32H246.703V128.168C246.703 126.056 247.759 125.096 249.583 125.096C250.927 125.096 251.935 125.336 253.087 125.72V119.672C251.695 119.24 250.111 118.952 247.759 118.952C245.119 118.952 243.055 119.624 241.663 121.016C240.271 122.456 239.551 124.568 239.551 127.544V129.272H236.335V135.272H239.551V155.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.149 137.816V127.448H289.069C292.957 127.448 295.357 129.224 295.357 132.584V132.68C295.357 135.752 293.053 137.816 289.213 137.816H281.149ZM273.805 155.72H281.149V144.344H287.533L295.261 155.72H303.901L295.165 143.096C299.677 141.512 302.797 137.96 302.797 132.296V132.2C302.797 128.984 301.789 126.248 299.869 124.328C297.565 122.024 294.109 120.776 289.693 120.776H273.805V155.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.565 156.296C326.413 156.296 329.965 154.424 332.461 151.352L328.285 147.656C326.173 149.624 324.301 150.44 321.661 150.44C318.157 150.44 315.661 148.568 314.941 144.92H333.709C333.757 144.248 333.805 143.576 333.805 143C333.805 135.416 329.677 128.552 320.845 128.552C313.117 128.552 307.693 134.792 307.693 142.424V142.52C307.693 150.68 313.597 156.296 321.565 156.296ZM314.845 140.36C315.421 136.76 317.581 134.408 320.845 134.408C324.205 134.408 326.221 136.856 326.701 140.36H314.845Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.903 156.152C351.399 156.152 353.175 155.576 354.759 154.664V148.808C353.655 149.384 352.407 149.72 351.015 149.72C349.239 149.72 348.423 148.856 348.423 146.984V135.272H354.855V129.032H348.423V122.12H341.127V129.032H337.911V135.272H341.127V148.184C341.127 154.328 344.295 156.152 348.903 156.152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.765 151.16C368.221 151.16 366.397 149.912 366.397 147.752V147.656C366.397 145.208 368.461 143.816 371.821 143.816C373.789 143.816 375.565 144.248 376.909 144.824V146.264C376.909 149.144 374.413 151.16 370.765 151.16ZM368.605 156.248C372.349 156.248 374.941 154.808 376.765 152.744V155.72H383.821V140.168C383.821 136.616 382.909 133.688 380.941 131.72C379.021 129.848 376.045 128.744 371.965 128.744C367.501 128.744 364.573 129.608 361.645 130.904L363.469 136.472C365.917 135.56 368.029 134.984 370.909 134.984C374.797 134.984 376.813 136.76 376.813 140.024V140.504C374.893 139.88 372.925 139.448 370.141 139.448C363.805 139.448 359.341 142.136 359.341 147.944V148.04C359.341 153.32 363.565 156.248 368.605 156.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.023 125.864H398.703V119.336H391.023V125.864ZM391.263 155.72H398.511V129.032H391.263V155.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.591 155.72H413.839V119.288H406.591V155.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 40.72H24.312V20.336H20V40.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7024 40.72H33.9304V27.448L44.0664 40.72H47.7344V20.336H43.4784V33.188L33.6504 20.336H29.7024V40.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4686 40.86H63.2766L71.5646 20.336H66.9166L61.4286 34.952L55.9406 20.336H51.1806L59.4686 40.86Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.011 40.72H90.467V36.884H79.267V32.376H89.011V28.54H79.267V24.172H90.327V20.336H75.011V40.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7532 40.72H98.9812V27.448L109.117 40.72H112.785V20.336H108.529V33.188L98.7012 20.336H94.7532V40.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.783 40.72H127.095V24.312H133.339V20.336H116.511V24.312H122.783V40.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.008 41.056C152.28 41.056 156.844 36.296 156.844 30.528V30.472C156.844 24.676 152.336 20 146.064 20C139.792 20 135.228 24.76 135.228 30.528V30.584C135.228 36.38 139.736 41.056 146.008 41.056ZM146.064 37.108C142.368 37.108 139.736 34.112 139.736 30.528V30.472C139.736 26.888 142.312 23.948 146.008 23.948C149.704 23.948 152.336 26.944 152.336 30.528V30.584C152.336 34.168 149.76 37.108 146.064 37.108Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.4 30.276V24.228H170.021C172.289 24.228 173.689 25.264 173.689 27.224V27.28C173.689 29.072 172.345 30.276 170.105 30.276H165.4ZM161.117 40.72H165.4V34.084H169.124L173.633 40.72H178.673L173.577 33.356C176.209 32.432 178.029 30.36 178.029 27.056V27C178.029 25.124 177.44 23.528 176.32 22.408C174.976 21.064 172.961 20.336 170.385 20.336H161.117V40.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.42 40.72H191.732V32.6L199.628 20.336H194.728L189.604 28.68L184.592 20.336H179.552L187.42 32.684V40.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.778 32.264L220.662 25.348L223.518 32.264H217.778ZM209.938 40.72H214.334L216.238 36.072H225.058L226.962 40.72H231.47L222.706 20.196H218.73L209.938 40.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.662 41.028C248.122 41.028 251.566 38.004 251.566 31.844V20.336H247.282V32.04C247.282 35.372 245.546 37.08 242.718 37.08C239.89 37.08 238.182 35.288 238.182 31.872V20.336H233.87V32.012C233.87 37.976 237.23 41.028 242.662 41.028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.225 40.72H265.537V24.312H271.781V20.336H254.953V24.312H261.225V40.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.449 41.056C290.721 41.056 295.285 36.296 295.285 30.528V30.472C295.285 24.676 290.777 20 284.505 20C278.233 20 273.669 24.76 273.669 30.528V30.584C273.669 36.38 278.177 41.056 284.449 41.056ZM284.505 37.108C280.809 37.108 278.177 34.112 278.177 30.528V30.472C278.177 26.888 280.753 23.948 284.449 23.948C288.145 23.948 290.777 26.944 290.777 30.528V30.584C290.777 34.168 288.201 37.108 284.505 37.108Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.558 40.72H303.758V27.224L309.582 36.044H309.694L315.574 27.14V40.72H319.858V20.336H315.238L309.694 29.156L304.178 20.336H299.558V40.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.146 32.264L334.03 25.348L336.886 32.264H331.146ZM323.306 40.72H327.702L329.606 36.072H338.426L340.33 40.72H344.838L336.074 20.196H332.098L323.306 40.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.502 40.72H354.814V24.312H361.058V20.336H344.23V24.312H350.502V40.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.969 40.72H369.281V20.336H364.969V40.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.527 41.056C390.799 41.056 395.363 36.296 395.363 30.528V30.472C395.363 24.676 390.855 20 384.583 20C378.311 20 373.747 24.76 373.747 30.528V30.584C373.747 36.38 378.255 41.056 384.527 41.056ZM384.583 37.108C380.887 37.108 378.255 34.112 378.255 30.528V30.472C378.255 26.888 380.831 23.948 384.527 23.948C388.223 23.948 390.855 26.944 390.855 30.528V30.584C390.855 34.168 388.279 37.108 384.583 37.108Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.636 40.72H403.864V27.448L414 40.72H417.668V20.336H413.412V33.188L403.584 20.336H399.636V40.72Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1003_148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.008 79.816V69.448H36.928C40.816 69.448 43.216 71.224 43.216 74.584V74.68C43.216 77.752 40.912 79.816 37.072 79.816H29.008ZM21.664 97.72H29.008V86.344H35.392L43.12 97.72H51.76L43.024 85.096C47.536 83.512 50.656 79.96 50.656 74.296V74.2C50.656 70.984 49.648 68.248 47.728 66.328C45.424 64.024 41.968 62.776 37.552 62.776H21.664V97.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.856 98.296C78.16 98.296 84.304 92.104 84.304 84.424V84.328C84.304 76.696 78.208 70.552 70 70.552C61.696 70.552 55.552 76.792 55.552 84.424V84.52C55.552 92.2 61.648 98.296 69.856 98.296ZM70 92.056C65.68 92.056 62.752 88.504 62.752 84.424V84.328C62.752 80.248 65.44 76.84 69.856 76.84C74.176 76.84 77.104 80.344 77.104 84.424V84.52C77.104 88.6 74.416 92.056 70 92.056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.061 98.248C112.397 98.248 118.253 93.304 118.253 84.424V84.328C118.253 75.448 112.301 70.552 106.061 70.552C102.077 70.552 99.4847 72.472 97.6127 75.016V61.288H90.3167V97.72H97.6127V94.12C99.4367 96.328 101.981 98.248 106.061 98.248ZM104.237 92.008C100.589 92.008 97.5168 88.984 97.5168 84.424V84.328C97.5168 79.768 100.589 76.744 104.237 76.744C107.885 76.744 110.957 79.768 110.957 84.328V84.424C110.957 89.08 107.885 92.008 104.237 92.008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.356 98.296C145.66 98.296 151.804 92.104 151.804 84.424V84.328C151.804 76.696 145.708 70.552 137.5 70.552C129.196 70.552 123.052 76.792 123.052 84.424V84.52C123.052 92.2 129.148 98.296 137.356 98.296ZM137.5 92.056C133.18 92.056 130.252 88.504 130.252 84.424V84.328C130.252 80.248 132.94 76.84 137.356 76.84C141.676 76.84 144.604 80.344 144.604 84.424V84.52C144.604 88.6 141.916 92.056 137.5 92.056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.841 98.152C169.337 98.152 171.113 97.576 172.697 96.664V90.808C171.593 91.384 170.345 91.72 168.953 91.72C167.177 91.72 166.361 90.856 166.361 88.984V77.272H172.793V71.032H166.361V64.12H159.065V71.032H155.849V77.272H159.065V90.184C159.065 96.328 162.233 98.152 166.841 98.152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.055 67.864H186.734V61.336H179.055V67.864ZM179.294 97.72H186.542V71.032H179.294V97.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.815 98.296C212.095 98.296 215.119 96.28 217.711 93.4L213.439 89.128C211.567 90.904 209.743 92.056 207.151 92.056C202.879 92.056 200.143 88.648 200.143 84.424V84.328C200.143 80.248 202.927 76.84 206.863 76.84C209.599 76.84 211.327 78.04 213.055 79.864L217.567 75.064C215.071 72.28 211.903 70.552 206.911 70.552C198.751 70.552 192.943 76.84 192.943 84.424V84.52C192.943 92.152 198.799 98.296 206.815 98.296Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.426 98.2C238.186 98.2 242.602 95.512 242.602 89.656V89.56C242.602 84.664 238.234 82.888 234.49 81.688C231.562 80.68 228.922 79.96 228.922 78.376V78.28C228.922 77.128 229.978 76.264 231.898 76.264C233.914 76.264 236.554 77.224 239.194 78.76L241.978 73.72C239.098 71.8 235.45 70.648 232.09 70.648C226.714 70.648 222.346 73.672 222.346 79.048V79.144C222.346 84.28 226.618 86.008 230.41 87.112C233.386 88.024 236.026 88.6 236.026 90.328V90.424C236.026 91.72 234.922 92.584 232.618 92.584C230.122 92.584 227.05 91.48 224.17 89.368L221.002 94.216C224.506 96.952 228.682 98.2 232.426 98.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.286 97.72H272.534V77.272H278.774V71.32H272.438V70.168C272.438 68.056 273.494 67.096 275.318 67.096C276.662 67.096 277.67 67.336 278.822 67.72V61.672C277.43 61.24 275.846 60.952 273.494 60.952C270.854 60.952 268.79 61.624 267.398 63.016C266.006 64.456 265.286 66.568 265.286 69.544V71.272H262.07V77.272H265.286V97.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.887 98.296C304.191 98.296 310.335 92.104 310.335 84.424V84.328C310.335 76.696 304.239 70.552 296.031 70.552C287.727 70.552 281.583 76.792 281.583 84.424V84.52C281.583 92.2 287.679 98.296 295.887 98.296ZM296.031 92.056C291.711 92.056 288.783 88.504 288.783 84.424V84.328C288.783 80.248 291.471 76.84 295.887 76.84C300.207 76.84 303.135 80.344 303.135 84.424V84.52C303.135 88.6 300.447 92.056 296.031 92.056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.348 97.72H323.644V87.784C323.644 81.304 326.86 78.184 331.948 78.184H332.332V70.552C327.82 70.36 325.228 72.808 323.644 76.552V71.032H316.348V97.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.981 98.152C364.477 98.152 366.253 97.576 367.837 96.664V90.808C366.733 91.384 365.485 91.72 364.093 91.72C362.317 91.72 361.501 90.856 361.501 88.984V77.272H367.933V71.032H361.501V64.12H354.205V71.032H350.989V77.272H354.205V90.184C354.205 96.328 357.373 98.152 361.981 98.152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.051 97.72H381.347V82.792C381.347 79.096 383.315 77.128 386.339 77.128C389.363 77.128 391.139 79.096 391.139 82.792V97.72H398.435V80.488C398.435 74.344 395.027 70.552 389.267 70.552C385.379 70.552 383.075 72.616 381.347 74.872V61.288H374.051V97.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.08 98.296C422.928 98.296 426.48 96.424 428.976 93.352L424.8 89.656C422.688 91.624 420.816 92.44 418.176 92.44C414.672 92.44 412.176 90.568 411.456 86.92H430.224C430.272 86.248 430.32 85.576 430.32 85C430.32 77.416 426.192 70.552 417.36 70.552C409.632 70.552 404.208 76.792 404.208 84.424V84.52C404.208 92.68 410.112 98.296 418.08 98.296ZM411.36 82.36C411.936 78.76 414.096 76.408 417.36 76.408C420.72 76.408 422.736 78.856 423.216 82.36H411.36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.664 155.72H29.008V142.04H45.904V135.32H29.008V127.496H48.112V120.776H21.664V155.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9166 156.248C66.8046 156.248 69.1086 154.184 70.8366 151.88V155.72H78.1326V129.032H70.8366V143.96C70.8366 147.656 68.8686 149.624 65.8446 149.624C62.8206 149.624 61.0446 147.656 61.0446 143.96V129.032H53.7966V146.264C53.7966 152.408 57.1566 156.248 62.9166 156.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4658 156.152C96.9618 156.152 98.7377 155.576 100.322 154.664V148.808C99.2177 149.384 97.9698 149.72 96.5778 149.72C94.8018 149.72 93.9857 148.856 93.9857 146.984V135.272H100.418V129.032H93.9857V122.12H86.6898V129.032H83.4738V135.272H86.6898V148.184C86.6898 154.328 89.8578 156.152 94.4658 156.152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.464 156.248C119.352 156.248 121.655 154.184 123.383 151.88V155.72H130.68V129.032H123.383V143.96C123.383 147.656 121.416 149.624 118.392 149.624C115.368 149.624 113.591 147.656 113.591 143.96V129.032H106.343V146.264C106.343 152.408 109.703 156.248 115.464 156.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.989 155.72H145.285V145.784C145.285 139.304 148.501 136.184 153.589 136.184H153.973V128.552C149.461 128.36 146.869 130.808 145.285 134.552V129.032H137.989V155.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.049 156.296C175.897 156.296 179.449 154.424 181.945 151.352L177.769 147.656C175.657 149.624 173.785 150.44 171.145 150.44C167.641 150.44 165.145 148.568 164.425 144.92H183.193C183.241 144.248 183.289 143.576 183.289 143C183.289 135.416 179.161 128.552 170.329 128.552C162.601 128.552 157.177 134.792 157.177 142.424V142.52C157.177 150.68 163.081 156.296 171.049 156.296ZM164.329 140.36C164.905 136.76 167.065 134.408 170.329 134.408C173.689 134.408 175.705 136.856 176.185 140.36H164.329Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.747 156.296C226.051 156.296 232.195 150.104 232.195 142.424V142.328C232.195 134.696 226.099 128.552 217.891 128.552C209.587 128.552 203.443 134.792 203.443 142.424V142.52C203.443 150.2 209.539 156.296 217.747 156.296ZM217.891 150.056C213.571 150.056 210.643 146.504 210.643 142.424V142.328C210.643 138.248 213.331 134.84 217.747 134.84C222.067 134.84 224.995 138.344 224.995 142.424V142.52C224.995 146.6 222.307 150.056 217.891 150.056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.551 155.72H246.799V135.272H253.039V129.32H246.703V128.168C246.703 126.056 247.759 125.096 249.583 125.096C250.927 125.096 251.935 125.336 253.087 125.72V119.672C251.695 119.24 250.111 118.952 247.759 118.952C245.119 118.952 243.055 119.624 241.663 121.016C240.271 122.456 239.551 124.568 239.551 127.544V129.272H236.335V135.272H239.551V155.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.149 137.816V127.448H289.069C292.957 127.448 295.357 129.224 295.357 132.584V132.68C295.357 135.752 293.053 137.816 289.213 137.816H281.149ZM273.805 155.72H281.149V144.344H287.533L295.261 155.72H303.901L295.165 143.096C299.677 141.512 302.797 137.96 302.797 132.296V132.2C302.797 128.984 301.789 126.248 299.869 124.328C297.565 122.024 294.109 120.776 289.693 120.776H273.805V155.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.565 156.296C326.413 156.296 329.965 154.424 332.461 151.352L328.285 147.656C326.173 149.624 324.301 150.44 321.661 150.44C318.157 150.44 315.661 148.568 314.941 144.92H333.709C333.757 144.248 333.805 143.576 333.805 143C333.805 135.416 329.677 128.552 320.845 128.552C313.117 128.552 307.693 134.792 307.693 142.424V142.52C307.693 150.68 313.597 156.296 321.565 156.296ZM314.845 140.36C315.421 136.76 317.581 134.408 320.845 134.408C324.205 134.408 326.221 136.856 326.701 140.36H314.845Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.903 156.152C351.399 156.152 353.175 155.576 354.759 154.664V148.808C353.655 149.384 352.407 149.72 351.015 149.72C349.239 149.72 348.423 148.856 348.423 146.984V135.272H354.855V129.032H348.423V122.12H341.127V129.032H337.911V135.272H341.127V148.184C341.127 154.328 344.295 156.152 348.903 156.152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.765 151.16C368.221 151.16 366.397 149.912 366.397 147.752V147.656C366.397 145.208 368.461 143.816 371.821 143.816C373.789 143.816 375.565 144.248 376.909 144.824V146.264C376.909 149.144 374.413 151.16 370.765 151.16ZM368.605 156.248C372.349 156.248 374.941 154.808 376.765 152.744V155.72H383.821V140.168C383.821 136.616 382.909 133.688 380.941 131.72C379.021 129.848 376.045 128.744 371.965 128.744C367.501 128.744 364.573 129.608 361.645 130.904L363.469 136.472C365.917 135.56 368.029 134.984 370.909 134.984C374.797 134.984 376.813 136.76 376.813 140.024V140.504C374.893 139.88 372.925 139.448 370.141 139.448C363.805 139.448 359.341 142.136 359.341 147.944V148.04C359.341 153.32 363.565 156.248 368.605 156.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.023 125.864H398.703V119.336H391.023V125.864ZM391.263 155.72H398.511V129.032H391.263V155.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.591 155.72H413.839V119.288H406.591V155.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 40.72H24.312V20.336H20V40.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7024 40.72H33.9304V27.448L44.0664 40.72H47.7344V20.336H43.4784V33.188L33.6504 20.336H29.7024V40.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4686 40.86H63.2766L71.5646 20.336H66.9166L61.4286 34.952L55.9406 20.336H51.1806L59.4686 40.86Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.011 40.72H90.467V36.884H79.267V32.376H89.011V28.54H79.267V24.172H90.327V20.336H75.011V40.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7532 40.72H98.9812V27.448L109.117 40.72H112.785V20.336H108.529V33.188L98.7012 20.336H94.7532V40.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.783 40.72H127.095V24.312H133.339V20.336H116.511V24.312H122.783V40.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.008 41.056C152.28 41.056 156.844 36.296 156.844 30.528V30.472C156.844 24.676 152.336 20 146.064 20C139.792 20 135.228 24.76 135.228 30.528V30.584C135.228 36.38 139.736 41.056 146.008 41.056ZM146.064 37.108C142.368 37.108 139.736 34.112 139.736 30.528V30.472C139.736 26.888 142.312 23.948 146.008 23.948C149.704 23.948 152.336 26.944 152.336 30.528V30.584C152.336 34.168 149.76 37.108 146.064 37.108Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.4 30.276V24.228H170.021C172.289 24.228 173.689 25.264 173.689 27.224V27.28C173.689 29.072 172.345 30.276 170.105 30.276H165.4ZM161.117 40.72H165.4V34.084H169.124L173.633 40.72H178.673L173.577 33.356C176.209 32.432 178.029 30.36 178.029 27.056V27C178.029 25.124 177.44 23.528 176.32 22.408C174.976 21.064 172.961 20.336 170.385 20.336H161.117V40.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.42 40.72H191.732V32.6L199.628 20.336H194.728L189.604 28.68L184.592 20.336H179.552L187.42 32.684V40.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.778 32.264L220.662 25.348L223.518 32.264H217.778ZM209.938 40.72H214.334L216.238 36.072H225.058L226.962 40.72H231.47L222.706 20.196H218.73L209.938 40.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.662 41.028C248.122 41.028 251.566 38.004 251.566 31.844V20.336H247.282V32.04C247.282 35.372 245.546 37.08 242.718 37.08C239.89 37.08 238.182 35.288 238.182 31.872V20.336H233.87V32.012C233.87 37.976 237.23 41.028 242.662 41.028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.225 40.72H265.537V24.312H271.781V20.336H254.953V24.312H261.225V40.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.449 41.056C290.721 41.056 295.285 36.296 295.285 30.528V30.472C295.285 24.676 290.777 20 284.505 20C278.233 20 273.669 24.76 273.669 30.528V30.584C273.669 36.38 278.177 41.056 284.449 41.056ZM284.505 37.108C280.809 37.108 278.177 34.112 278.177 30.528V30.472C278.177 26.888 280.753 23.948 284.449 23.948C288.145 23.948 290.777 26.944 290.777 30.528V30.584C290.777 34.168 288.201 37.108 284.505 37.108Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.558 40.72H303.758V27.224L309.582 36.044H309.694L315.574 27.14V40.72H319.858V20.336H315.238L309.694 29.156L304.178 20.336H299.558V40.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.146 32.264L334.03 25.348L336.886 32.264H331.146ZM323.306 40.72H327.702L329.606 36.072H338.426L340.33 40.72H344.838L336.074 20.196H332.098L323.306 40.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.502 40.72H354.814V24.312H361.058V20.336H344.23V24.312H350.502V40.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.969 40.72H369.281V20.336H364.969V40.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.527 41.056C390.799 41.056 395.363 36.296 395.363 30.528V30.472C395.363 24.676 390.855 20 384.583 20C378.311 20 373.747 24.76 373.747 30.528V30.584C373.747 36.38 378.255 41.056 384.527 41.056ZM384.583 37.108C380.887 37.108 378.255 34.112 378.255 30.528V30.472C378.255 26.888 380.831 23.948 384.527 23.948C388.223 23.948 390.855 26.944 390.855 30.528V30.584C390.855 34.168 388.279 37.108 384.583 37.108Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.636 40.72H403.864V27.448L414 40.72H417.668V20.336H413.412V33.188L403.584 20.336H399.636V40.72Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.008 79.816V69.448H36.928C40.816 69.448 43.216 71.224 43.216 74.584V74.68C43.216 77.752 40.912 79.816 37.072 79.816H29.008ZM21.664 97.72H29.008V86.344H35.392L43.12 97.72H51.76L43.024 85.096C47.536 83.512 50.656 79.96 50.656 74.296V74.2C50.656 70.984 49.648 68.248 47.728 66.328C45.424 64.024 41.968 62.776 37.552 62.776H21.664V97.72Z",
    fill: "url(#paint0_linear_1003_148)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.856 98.296C78.16 98.296 84.304 92.104 84.304 84.424V84.328C84.304 76.696 78.208 70.552 70 70.552C61.696 70.552 55.552 76.792 55.552 84.424V84.52C55.552 92.2 61.648 98.296 69.856 98.296ZM70 92.056C65.68 92.056 62.752 88.504 62.752 84.424V84.328C62.752 80.248 65.44 76.84 69.856 76.84C74.176 76.84 77.104 80.344 77.104 84.424V84.52C77.104 88.6 74.416 92.056 70 92.056Z",
    fill: "url(#paint1_linear_1003_148)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.061 98.248C112.397 98.248 118.253 93.304 118.253 84.424V84.328C118.253 75.448 112.301 70.552 106.061 70.552C102.077 70.552 99.4847 72.472 97.6127 75.016V61.288H90.3167V97.72H97.6127V94.12C99.4367 96.328 101.981 98.248 106.061 98.248ZM104.237 92.008C100.589 92.008 97.5168 88.984 97.5168 84.424V84.328C97.5168 79.768 100.589 76.744 104.237 76.744C107.885 76.744 110.957 79.768 110.957 84.328V84.424C110.957 89.08 107.885 92.008 104.237 92.008Z",
    fill: "url(#paint2_linear_1003_148)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M137.356 98.296C145.66 98.296 151.804 92.104 151.804 84.424V84.328C151.804 76.696 145.708 70.552 137.5 70.552C129.196 70.552 123.052 76.792 123.052 84.424V84.52C123.052 92.2 129.148 98.296 137.356 98.296ZM137.5 92.056C133.18 92.056 130.252 88.504 130.252 84.424V84.328C130.252 80.248 132.94 76.84 137.356 76.84C141.676 76.84 144.604 80.344 144.604 84.424V84.52C144.604 88.6 141.916 92.056 137.5 92.056Z",
    fill: "url(#paint3_linear_1003_148)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M166.841 98.152C169.337 98.152 171.113 97.576 172.697 96.664V90.808C171.593 91.384 170.345 91.72 168.953 91.72C167.177 91.72 166.361 90.856 166.361 88.984V77.272H172.793V71.032H166.361V64.12H159.065V71.032H155.849V77.272H159.065V90.184C159.065 96.328 162.233 98.152 166.841 98.152Z",
    fill: "url(#paint4_linear_1003_148)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M179.055 67.864H186.734V61.336H179.055V67.864ZM179.294 97.72H186.542V71.032H179.294V97.72Z",
    fill: "url(#paint5_linear_1003_148)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M206.815 98.296C212.095 98.296 215.119 96.28 217.711 93.4L213.439 89.128C211.567 90.904 209.743 92.056 207.151 92.056C202.879 92.056 200.143 88.648 200.143 84.424V84.328C200.143 80.248 202.927 76.84 206.863 76.84C209.599 76.84 211.327 78.04 213.055 79.864L217.567 75.064C215.071 72.28 211.903 70.552 206.911 70.552C198.751 70.552 192.943 76.84 192.943 84.424V84.52C192.943 92.152 198.799 98.296 206.815 98.296Z",
    fill: "url(#paint6_linear_1003_148)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M232.426 98.2C238.186 98.2 242.602 95.512 242.602 89.656V89.56C242.602 84.664 238.234 82.888 234.49 81.688C231.562 80.68 228.922 79.96 228.922 78.376V78.28C228.922 77.128 229.978 76.264 231.898 76.264C233.914 76.264 236.554 77.224 239.194 78.76L241.978 73.72C239.098 71.8 235.45 70.648 232.09 70.648C226.714 70.648 222.346 73.672 222.346 79.048V79.144C222.346 84.28 226.618 86.008 230.41 87.112C233.386 88.024 236.026 88.6 236.026 90.328V90.424C236.026 91.72 234.922 92.584 232.618 92.584C230.122 92.584 227.05 91.48 224.17 89.368L221.002 94.216C224.506 96.952 228.682 98.2 232.426 98.2Z",
    fill: "url(#paint7_linear_1003_148)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M265.286 97.72H272.534V77.272H278.774V71.32H272.438V70.168C272.438 68.056 273.494 67.096 275.318 67.096C276.662 67.096 277.67 67.336 278.822 67.72V61.672C277.43 61.24 275.846 60.952 273.494 60.952C270.854 60.952 268.79 61.624 267.398 63.016C266.006 64.456 265.286 66.568 265.286 69.544V71.272H262.07V77.272H265.286V97.72Z",
    fill: "url(#paint8_linear_1003_148)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M295.887 98.296C304.191 98.296 310.335 92.104 310.335 84.424V84.328C310.335 76.696 304.239 70.552 296.031 70.552C287.727 70.552 281.583 76.792 281.583 84.424V84.52C281.583 92.2 287.679 98.296 295.887 98.296ZM296.031 92.056C291.711 92.056 288.783 88.504 288.783 84.424V84.328C288.783 80.248 291.471 76.84 295.887 76.84C300.207 76.84 303.135 80.344 303.135 84.424V84.52C303.135 88.6 300.447 92.056 296.031 92.056Z",
    fill: "url(#paint9_linear_1003_148)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M316.348 97.72H323.644V87.784C323.644 81.304 326.86 78.184 331.948 78.184H332.332V70.552C327.82 70.36 325.228 72.808 323.644 76.552V71.032H316.348V97.72Z",
    fill: "url(#paint10_linear_1003_148)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M361.981 98.152C364.477 98.152 366.253 97.576 367.837 96.664V90.808C366.733 91.384 365.485 91.72 364.093 91.72C362.317 91.72 361.501 90.856 361.501 88.984V77.272H367.933V71.032H361.501V64.12H354.205V71.032H350.989V77.272H354.205V90.184C354.205 96.328 357.373 98.152 361.981 98.152Z",
    fill: "url(#paint11_linear_1003_148)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M374.051 97.72H381.347V82.792C381.347 79.096 383.315 77.128 386.339 77.128C389.363 77.128 391.139 79.096 391.139 82.792V97.72H398.435V80.488C398.435 74.344 395.027 70.552 389.267 70.552C385.379 70.552 383.075 72.616 381.347 74.872V61.288H374.051V97.72Z",
    fill: "url(#paint12_linear_1003_148)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M418.08 98.296C422.928 98.296 426.48 96.424 428.976 93.352L424.8 89.656C422.688 91.624 420.816 92.44 418.176 92.44C414.672 92.44 412.176 90.568 411.456 86.92H430.224C430.272 86.248 430.32 85.576 430.32 85C430.32 77.416 426.192 70.552 417.36 70.552C409.632 70.552 404.208 76.792 404.208 84.424V84.52C404.208 92.68 410.112 98.296 418.08 98.296ZM411.36 82.36C411.936 78.76 414.096 76.408 417.36 76.408C420.72 76.408 422.736 78.856 423.216 82.36H411.36Z",
    fill: "url(#paint13_linear_1003_148)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.664 155.72H29.008V142.04H45.904V135.32H29.008V127.496H48.112V120.776H21.664V155.72Z",
    fill: "url(#paint14_linear_1003_148)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9166 156.248C66.8046 156.248 69.1086 154.184 70.8366 151.88V155.72H78.1326V129.032H70.8366V143.96C70.8366 147.656 68.8686 149.624 65.8446 149.624C62.8206 149.624 61.0446 147.656 61.0446 143.96V129.032H53.7966V146.264C53.7966 152.408 57.1566 156.248 62.9166 156.248Z",
    fill: "url(#paint15_linear_1003_148)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4658 156.152C96.9618 156.152 98.7377 155.576 100.322 154.664V148.808C99.2177 149.384 97.9698 149.72 96.5778 149.72C94.8018 149.72 93.9857 148.856 93.9857 146.984V135.272H100.418V129.032H93.9857V122.12H86.6898V129.032H83.4738V135.272H86.6898V148.184C86.6898 154.328 89.8578 156.152 94.4658 156.152Z",
    fill: "url(#paint16_linear_1003_148)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M115.464 156.248C119.352 156.248 121.655 154.184 123.383 151.88V155.72H130.68V129.032H123.383V143.96C123.383 147.656 121.416 149.624 118.392 149.624C115.368 149.624 113.591 147.656 113.591 143.96V129.032H106.343V146.264C106.343 152.408 109.703 156.248 115.464 156.248Z",
    fill: "url(#paint17_linear_1003_148)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M137.989 155.72H145.285V145.784C145.285 139.304 148.501 136.184 153.589 136.184H153.973V128.552C149.461 128.36 146.869 130.808 145.285 134.552V129.032H137.989V155.72Z",
    fill: "url(#paint18_linear_1003_148)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M171.049 156.296C175.897 156.296 179.449 154.424 181.945 151.352L177.769 147.656C175.657 149.624 173.785 150.44 171.145 150.44C167.641 150.44 165.145 148.568 164.425 144.92H183.193C183.241 144.248 183.289 143.576 183.289 143C183.289 135.416 179.161 128.552 170.329 128.552C162.601 128.552 157.177 134.792 157.177 142.424V142.52C157.177 150.68 163.081 156.296 171.049 156.296ZM164.329 140.36C164.905 136.76 167.065 134.408 170.329 134.408C173.689 134.408 175.705 136.856 176.185 140.36H164.329Z",
    fill: "url(#paint19_linear_1003_148)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M217.747 156.296C226.051 156.296 232.195 150.104 232.195 142.424V142.328C232.195 134.696 226.099 128.552 217.891 128.552C209.587 128.552 203.443 134.792 203.443 142.424V142.52C203.443 150.2 209.539 156.296 217.747 156.296ZM217.891 150.056C213.571 150.056 210.643 146.504 210.643 142.424V142.328C210.643 138.248 213.331 134.84 217.747 134.84C222.067 134.84 224.995 138.344 224.995 142.424V142.52C224.995 146.6 222.307 150.056 217.891 150.056Z",
    fill: "url(#paint20_linear_1003_148)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M239.551 155.72H246.799V135.272H253.039V129.32H246.703V128.168C246.703 126.056 247.759 125.096 249.583 125.096C250.927 125.096 251.935 125.336 253.087 125.72V119.672C251.695 119.24 250.111 118.952 247.759 118.952C245.119 118.952 243.055 119.624 241.663 121.016C240.271 122.456 239.551 124.568 239.551 127.544V129.272H236.335V135.272H239.551V155.72Z",
    fill: "url(#paint21_linear_1003_148)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M281.149 137.816V127.448H289.069C292.957 127.448 295.357 129.224 295.357 132.584V132.68C295.357 135.752 293.053 137.816 289.213 137.816H281.149ZM273.805 155.72H281.149V144.344H287.533L295.261 155.72H303.901L295.165 143.096C299.677 141.512 302.797 137.96 302.797 132.296V132.2C302.797 128.984 301.789 126.248 299.869 124.328C297.565 122.024 294.109 120.776 289.693 120.776H273.805V155.72Z",
    fill: "url(#paint22_linear_1003_148)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M321.565 156.296C326.413 156.296 329.965 154.424 332.461 151.352L328.285 147.656C326.173 149.624 324.301 150.44 321.661 150.44C318.157 150.44 315.661 148.568 314.941 144.92H333.709C333.757 144.248 333.805 143.576 333.805 143C333.805 135.416 329.677 128.552 320.845 128.552C313.117 128.552 307.693 134.792 307.693 142.424V142.52C307.693 150.68 313.597 156.296 321.565 156.296ZM314.845 140.36C315.421 136.76 317.581 134.408 320.845 134.408C324.205 134.408 326.221 136.856 326.701 140.36H314.845Z",
    fill: "url(#paint23_linear_1003_148)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M348.903 156.152C351.399 156.152 353.175 155.576 354.759 154.664V148.808C353.655 149.384 352.407 149.72 351.015 149.72C349.239 149.72 348.423 148.856 348.423 146.984V135.272H354.855V129.032H348.423V122.12H341.127V129.032H337.911V135.272H341.127V148.184C341.127 154.328 344.295 156.152 348.903 156.152Z",
    fill: "url(#paint24_linear_1003_148)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M370.765 151.16C368.221 151.16 366.397 149.912 366.397 147.752V147.656C366.397 145.208 368.461 143.816 371.821 143.816C373.789 143.816 375.565 144.248 376.909 144.824V146.264C376.909 149.144 374.413 151.16 370.765 151.16ZM368.605 156.248C372.349 156.248 374.941 154.808 376.765 152.744V155.72H383.821V140.168C383.821 136.616 382.909 133.688 380.941 131.72C379.021 129.848 376.045 128.744 371.965 128.744C367.501 128.744 364.573 129.608 361.645 130.904L363.469 136.472C365.917 135.56 368.029 134.984 370.909 134.984C374.797 134.984 376.813 136.76 376.813 140.024V140.504C374.893 139.88 372.925 139.448 370.141 139.448C363.805 139.448 359.341 142.136 359.341 147.944V148.04C359.341 153.32 363.565 156.248 368.605 156.248Z",
    fill: "url(#paint25_linear_1003_148)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M391.023 125.864H398.703V119.336H391.023V125.864ZM391.263 155.72H398.511V129.032H391.263V155.72Z",
    fill: "url(#paint26_linear_1003_148)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M406.591 155.72H413.839V119.288H406.591V155.72Z",
    fill: "url(#paint27_linear_1003_148)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M20 40.72H24.312V20.336H20V40.72Z",
    fill: "url(#paint28_linear_1003_148)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7024 40.72H33.9304V27.448L44.0664 40.72H47.7344V20.336H43.4784V33.188L33.6504 20.336H29.7024V40.72Z",
    fill: "url(#paint29_linear_1003_148)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4686 40.86H63.2766L71.5646 20.336H66.9166L61.4286 34.952L55.9406 20.336H51.1806L59.4686 40.86Z",
    fill: "url(#paint30_linear_1003_148)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M75.011 40.72H90.467V36.884H79.267V32.376H89.011V28.54H79.267V24.172H90.327V20.336H75.011V40.72Z",
    fill: "url(#paint31_linear_1003_148)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7532 40.72H98.9812V27.448L109.117 40.72H112.785V20.336H108.529V33.188L98.7012 20.336H94.7532V40.72Z",
    fill: "url(#paint32_linear_1003_148)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M122.783 40.72H127.095V24.312H133.339V20.336H116.511V24.312H122.783V40.72Z",
    fill: "url(#paint33_linear_1003_148)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M146.008 41.056C152.28 41.056 156.844 36.296 156.844 30.528V30.472C156.844 24.676 152.336 20 146.064 20C139.792 20 135.228 24.76 135.228 30.528V30.584C135.228 36.38 139.736 41.056 146.008 41.056ZM146.064 37.108C142.368 37.108 139.736 34.112 139.736 30.528V30.472C139.736 26.888 142.312 23.948 146.008 23.948C149.704 23.948 152.336 26.944 152.336 30.528V30.584C152.336 34.168 149.76 37.108 146.064 37.108Z",
    fill: "url(#paint34_linear_1003_148)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M165.4 30.276V24.228H170.021C172.289 24.228 173.689 25.264 173.689 27.224V27.28C173.689 29.072 172.345 30.276 170.105 30.276H165.4ZM161.117 40.72H165.4V34.084H169.124L173.633 40.72H178.673L173.577 33.356C176.209 32.432 178.029 30.36 178.029 27.056V27C178.029 25.124 177.44 23.528 176.32 22.408C174.976 21.064 172.961 20.336 170.385 20.336H161.117V40.72Z",
    fill: "url(#paint35_linear_1003_148)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M187.42 40.72H191.732V32.6L199.628 20.336H194.728L189.604 28.68L184.592 20.336H179.552L187.42 32.684V40.72Z",
    fill: "url(#paint36_linear_1003_148)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M217.778 32.264L220.662 25.348L223.518 32.264H217.778ZM209.938 40.72H214.334L216.238 36.072H225.058L226.962 40.72H231.47L222.706 20.196H218.73L209.938 40.72Z",
    fill: "url(#paint37_linear_1003_148)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M242.662 41.028C248.122 41.028 251.566 38.004 251.566 31.844V20.336H247.282V32.04C247.282 35.372 245.546 37.08 242.718 37.08C239.89 37.08 238.182 35.288 238.182 31.872V20.336H233.87V32.012C233.87 37.976 237.23 41.028 242.662 41.028Z",
    fill: "url(#paint38_linear_1003_148)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M261.225 40.72H265.537V24.312H271.781V20.336H254.953V24.312H261.225V40.72Z",
    fill: "url(#paint39_linear_1003_148)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M284.449 41.056C290.721 41.056 295.285 36.296 295.285 30.528V30.472C295.285 24.676 290.777 20 284.505 20C278.233 20 273.669 24.76 273.669 30.528V30.584C273.669 36.38 278.177 41.056 284.449 41.056ZM284.505 37.108C280.809 37.108 278.177 34.112 278.177 30.528V30.472C278.177 26.888 280.753 23.948 284.449 23.948C288.145 23.948 290.777 26.944 290.777 30.528V30.584C290.777 34.168 288.201 37.108 284.505 37.108Z",
    fill: "url(#paint40_linear_1003_148)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M299.558 40.72H303.758V27.224L309.582 36.044H309.694L315.574 27.14V40.72H319.858V20.336H315.238L309.694 29.156L304.178 20.336H299.558V40.72Z",
    fill: "url(#paint41_linear_1003_148)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M331.146 32.264L334.03 25.348L336.886 32.264H331.146ZM323.306 40.72H327.702L329.606 36.072H338.426L340.33 40.72H344.838L336.074 20.196H332.098L323.306 40.72Z",
    fill: "url(#paint42_linear_1003_148)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M350.502 40.72H354.814V24.312H361.058V20.336H344.23V24.312H350.502V40.72Z",
    fill: "url(#paint43_linear_1003_148)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M364.969 40.72H369.281V20.336H364.969V40.72Z",
    fill: "url(#paint44_linear_1003_148)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M384.527 41.056C390.799 41.056 395.363 36.296 395.363 30.528V30.472C395.363 24.676 390.855 20 384.583 20C378.311 20 373.747 24.76 373.747 30.528V30.584C373.747 36.38 378.255 41.056 384.527 41.056ZM384.583 37.108C380.887 37.108 378.255 34.112 378.255 30.528V30.472C378.255 26.888 380.831 23.948 384.527 23.948C388.223 23.948 390.855 26.944 390.855 30.528V30.584C390.855 34.168 388.279 37.108 384.583 37.108Z",
    fill: "url(#paint45_linear_1003_148)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M399.636 40.72H403.864V27.448L414 40.72H417.668V20.336H413.412V33.188L403.584 20.336H399.636V40.72Z",
    fill: "url(#paint46_linear_1003_148)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1003_148",
    x: 10,
    y: 10,
    width: 430.32,
    height: 156.296,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_1003_148"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1003_148",
    x: 0,
    y: 0,
    width: 450.32,
    height: 176.296,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_1003_148"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1003_148",
    x1: 4.7002,
    y1: -25.78,
    x2: 355.2,
    y2: 134.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroTagline);
export default __webpack_public_path__ + "static/media/hero_tagline.7a471ceb428b73687c72bb44a0db3121.svg";
export { ForwardRef as ReactComponent };